import { render, staticRenderFns } from "./CacaOfertas.vue?vue&type=template&id=661661fe"
import script from "./CacaOfertas.vue?vue&type=script&lang=js"
export * from "./CacaOfertas.vue?vue&type=script&lang=js"
import style0 from "./CacaOfertas.vue?vue&type=style&index=0&id=661661fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports